// extracted by mini-css-extract-plugin
module.exports = {"boxEntitySubTitle":"BoxSubTitle_boxEntitySubTitle__Cdd73","subTitleBold":"BoxSubTitle_subTitleBold__2h4ma"};